module.exports = __webpack_public_path__ + "img/1.5.e20f225a.png";